
document.addEventListener('DOMContentLoaded', function(){
  // アコーディオン処理
  const animTiming = {
    duration: 300,
    easing: 'ease-in-out',
    fill: 'forwards'
  };

  // アニメーションキーフレームの生成
  const animKeyframes = (isOpening, contentHeight, paddingTop, paddingBottom) => {
    return [
      {
        opacity: isOpening ? 0 : 1,
        height: isOpening ? '0px' : contentHeight + 'px',
        paddingTop: isOpening ? '0px' : paddingTop + 'px',
        paddingBottom: isOpening ? '0px' : paddingBottom + 'px',
      },
      {
        opacity: isOpening ? 1 : 0,
        height: isOpening ? contentHeight + 'px' : '0px',
        paddingTop: isOpening ? paddingTop + 'px' : '0px',
        paddingBottom: isOpening ? paddingBottom + 'px' : '0px',
      }
    ];
  };

  const detailsElements = document.querySelectorAll(".shoplist__accordion");

  detailsElements.forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.shoplist__accordion__content');

    // 初期のpadding取得
    const computedStyle = window.getComputedStyle(content);
    const paddingTop = parseFloat(computedStyle.paddingTop);
    const paddingBottom = parseFloat(computedStyle.paddingBottom);

    // 初期のheight取得
    const contentHeight = content.scrollHeight;

    // 初期状態の設定
    if (details.open) {
      content.style.height = contentHeight + 'px';
      content.style.opacity = '1';
      content.style.paddingTop = paddingTop + 'px';
      content.style.paddingBottom = paddingBottom + 'px';
    } else {
      content.style.height = '0px';
      content.style.opacity = '0';
      content.style.paddingTop = '0px';
      content.style.paddingBottom = '0px';
    }

    // 各アコーディオンへイベント設置
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const isOpening = !details.open;

      if (isOpening) {
        details.open = true;
        content.style.overflow = 'hidden';

        // 開くアニメーションの実行
        const animation = content.animate(
          animKeyframes(isOpening, contentHeight, paddingTop, paddingBottom),
          animTiming
        );

        // 開くアニメーション完了時の処理
        animation.onfinish = () => {
          content.style.height = contentHeight + 'px';
          content.style.opacity = '1';
          content.style.paddingTop = paddingTop + 'px';
          content.style.paddingBottom = paddingBottom + 'px';
          content.style.overflow = '';
        };

        details.classList.remove('close');
        details.classList.add('open');
      } else {
        // 閉じるアニメーションの実行
        const animation = content.animate(
          animKeyframes(isOpening, contentHeight, paddingTop, paddingBottom),
          animTiming
        );

        // 閉じるアニメーション完了時の処理
        animation.onfinish = () => {
          details.open = false;
          content.style.height = '0px';
          content.style.opacity = '0';
          content.style.paddingTop = '0px';
          content.style.paddingBottom = '0px';
          content.style.overflow = 'hidden';
        };

        details.classList.remove('open');
        details.classList.add('close');
      }
    });
  });
});